import { render, staticRenderFns } from "./NoLandscape.vue?vue&type=template&id=0dd8bdbe&"
import script from "./NoLandscape.vue?vue&type=script&lang=ts&"
export * from "./NoLandscape.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports